var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxUserPanoramaView = function Svg18PxUserPanoramaView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.93 12.282a.995.995 0 0 0 1.32-.945V2.75a.995.995 0 0 0-1.32-.945c-1.464.503-3.5.99-5.93.991a18.4 18.4 0 0 1-5.93-.991.995.995 0 0 0-1.32.945v8.587a.995.995 0 0 0 1.32.945"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 7,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.801 15.776c-.489-.148-.818-.635-.709-1.135a4.001 4.001 0 0 1 7.816 0c.109.499-.219.987-.709 1.135a11.028 11.028 0 0 1-6.398 0"
  }))));
};
export default Svg18PxUserPanoramaView;